<template>
  <CrisantemiDesktop v-if="!$vuetify.breakpoint.mobile" />
  <v-card v-else class="pa-6 text-center grey--text">
Il modulo crisantemi è disponibile solo su desktop.
  </v-card>
</template>

<script>
import CrisantemiDesktop from "@/components/Crisantemi/Desktop/CrisantemiDesktop.vue";
export default {
  components: { CrisantemiDesktop },
};
</script>
